<script>
const {sitebot} = window

export default {
  name: 'SiteBot',
  data() {
    return {
      sitebot: null
    }
  },
  mounted() {
    if (!process.env.VUE_APP_SITEBOT_ENABLED) return

    this.sitebot = sitebot({
      id: process.env.VUE_APP_SITEBOT_WEBSITE_ID,
      authToken: process.env.VUE_APP_SITEBOT_API_TOKEN,
      locale: this.$i18n.locale,
    })
  },
  watch: {
    '$i18n.locale'(to) {
      if (!process.env.VUE_APP_SITEBOT_ENABLED) return

      this.sitebot.setLocale(to)
    }
  }
}
</script>